/**
 * CRO PDP JavaScript — Livera Shield (cro-test-firmhouse)
 * 3-kaart structuur: 1x Shield (eenmalig), Enkel Abo (60d), Dubbel Abo (60d)
 *
 * Selling plan logica:
 *  - 1x Shield (vi=0):        geen selling plan → eenmalig
 *  - Enkel Abonnement (vi=1): selling plan 692172587354
 *  - Dubbel Abonnement (vi=2): selling plan 692172587354
 *
 * Submit interceptor (capture phase) injecteert selling_plan vlak voor submit
 * zodat Firmhouse widget niet kan resetten.
 */

(function () {
  'use strict';

  // ─── I18N HELPERS ───────────────────────────────────────────────
  function getAtcText() {
    var el = document.getElementById('cro-i18n-atc-text');
    return el ? el.textContent.trim() : 'Add to cart';
  }
  function getOutOfStockText() {
    var el = document.getElementById('cro-i18n-oos-text');
    return el ? el.textContent.trim() : 'Sold out';
  }
  function getDaysUnit() {
    var el = document.getElementById('cro-i18n-days-unit');
    return el ? el.textContent.trim() : 'days';
  }
  const CART_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';

  // Pending selling plan IDD — ingesteld bij variant selectie, geïnjecteerd bij submit
  let pendingSellingPlanId = null;

  // ─── SELLING PLAN INJECT ─────────────────────────────────────────
  function setSellingPlan(planId) {
    pendingSellingPlanId = planId || null;
  }

  // ─── VARIANT SWITCHING ───────────────────────────────────────────
  window.croSelectVariant = function (radioInput) {
    const card = radioInput.closest('.cro-variant-card');
    const variantId = card.dataset.variantId;
    const price = card.dataset.price;
    const perDay = card.dataset.perDay;
    const compare = card.dataset.compare;
    const sellingPlan = card.dataset.sellingPlan || '';

    // Deselect all cards
    document.querySelectorAll('.cro-variant-card').forEach(c => {
      c.classList.remove('cro-variant-card--selected');
    });
    card.classList.add('cro-variant-card--selected');

    // Update hidden form input
    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    // Set pending selling plan
    setSellingPlan(sellingPlan);

    // Update price display
    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');

    if (priceEl) priceEl.textContent = price;
    if (perDayEl) {
      if (perDayEl.childNodes[0]) perDayEl.childNodes[0].textContent = perDay;
      else perDayEl.textContent = perDay;
    }

    // Show/hide compare price and savings badge
    const savingsBadge = document.getElementById('cro-savings-badge');
    if (compare) {
      if (compareEl) { compareEl.textContent = compare; compareEl.style.display = ''; }
      if (savingsEl) {
        const priceNum = parseFloat(price.replace('€', '').replace(',', '.'));
        const compareNum = parseFloat(compare.replace('€', '').replace(',', '.'));
        const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
        savingsEl.textContent = '€' + savings;
      }
      if (savingsBadge) savingsBadge.style.display = '';
    } else {
      if (compareEl) { compareEl.textContent = ''; compareEl.style.display = 'none'; }
      if (savingsBadge) savingsBadge.style.display = 'none';
    }

    // Update sticky bar
    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    const variantTitle = card.dataset.variantTitle || '';
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) {
      if (stickyPerDay.childNodes[0]) stickyPerDay.childNodes[0].textContent = perDay;
      else stickyPerDay.textContent = perDay;
    }

    // Update ATC button availability
    const atcBtn = document.getElementById('cro-atc-btn');
    const available = card.dataset.available === 'true';
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.innerHTML = available
        ? CART_SVG + ' ' + getAtcText()
        : getOutOfStockText();
    }

    // Toggle lock-in banner: hide for eenmalig (vi=0), show for abonnement
    const lockinBanner = document.getElementById('cro-lockin-banner');
    if (lockinBanner) {
      const vi = parseInt(card.dataset.vi || '1');
      if (vi === 0) {
        lockinBanner.classList.add('cro-lockin-banner--hidden');
      } else {
        lockinBanner.classList.remove('cro-lockin-banner--hidden');
      }
    }
  };

  // ─── SUBMIT INTERCEPTOR (capture phase) ─────────────────────────
  // Injecteert selling_plan vlak voor submit, zodat Firmhouse niet kan resetten
  const productForm = document.querySelector('.cro-product-form');
  if (productForm) {
    document.addEventListener('submit', function (e) {
      if (e.target !== productForm) return;
      // Verwijder alle bestaande selling_plan inputs
      productForm.querySelectorAll('input[name="selling_plan"]').forEach(el => el.remove());
      if (pendingSellingPlanId) {
        const sp = document.createElement('input');
        sp.type = 'hidden';
        sp.name = 'selling_plan';
        sp.value = pendingSellingPlanId;
        productForm.appendChild(sp);
      }
    }, true); // capture phase
  }

  // ─── STICKY ATC BAR ──────────────────────────────────────────────
  const stickyBar = document.getElementById('cro-sticky-bar');
  const atcBtn = document.getElementById('cro-atc-btn');

  if (stickyBar && atcBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('cro-sticky-bar--visible');
        } else {
          stickyBar.classList.remove('cro-sticky-bar--visible');
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(atcBtn);
  }

  // ─── STICKY ATC CLICK ────────────────────────────────────────────
  window.croStickyATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    const form = document.querySelector('.cro-product-form');
    if (form) {
      form.querySelector('[name="id"]').value = variantId;
      form.submit();
    }
  };

  // ─── IMAGE SWITCHER met overlay toggle ─────────────────────────
  window.croSwitchImage = function (thumbBtn) {
    const newSrc = thumbBtn.dataset.src;
    const showOverlay = thumbBtn.dataset.overlay === 'true';
    const mainImg = document.getElementById('cro-main-image');
    const overlay = document.getElementById('cro-img-overlay');
    if (mainImg) {
      mainImg.src = newSrc;
      mainImg.style.opacity = '0';
      setTimeout(() => { mainImg.style.opacity = '1'; }, 50);
    }
    if (overlay) {
      overlay.style.display = showOverlay ? 'flex' : 'none';
    }
    document.querySelectorAll('.cro-thumb').forEach(t => t.classList.remove('cro-thumb--active'));
    thumbBtn.classList.add('cro-thumb--active');
  };

  // ─── SMOOTH TRANSITION FOR MAIN IMAGE ───────────────────────────
  const mainImg = document.getElementById('cro-main-image');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.2s ease';
  }

  // ─── VIEWER COUNT ANIMATIE ───────────────────────────────────────
  const viewerEl = document.getElementById('cro-viewer-count');
  if (viewerEl) {
    let count = parseInt(viewerEl.textContent) || 23;
    setInterval(() => {
      const delta = Math.random() < 0.5 ? 1 : -1;
      count = Math.max(18, Math.min(31, count + delta));
      viewerEl.textContent = count;
    }, 7000);
  }

  // ─── STOCK COUNT ANIMATIE ────────────────────────────────────────
  const stockEl = document.getElementById('cro-stock-count');
  if (stockEl) {
    let stock = parseInt(stockEl.textContent) || 14;
    const stockInterval = setInterval(() => {
      if (stock > 7) {
        stock -= 1;
        stockEl.textContent = stock;
      } else {
        clearInterval(stockInterval);
      }
    }, Math.floor(Math.random() * 120000) + 180000);
  }

  // ─── FAQ SMOOTH OPEN ─────────────────────────────────────────────
  document.querySelectorAll('.cro-faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        document.querySelectorAll('.cro-faq-item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  // ─── MID-PAGE CTA VARIANT SELECT ─────────────────────────────────
  window.croMidCtaSelect = function (btn) {
    document.querySelectorAll('.cro-midcta-variant').forEach(b => b.classList.remove('cro-midcta-variant--selected'));
    btn.classList.add('cro-midcta-variant--selected');

    const variantId = btn.dataset.variantId;
    const price = btn.dataset.price;
    const perDay = btn.dataset.perDay;
    const compare = btn.dataset.compare;
    const variantTitle = btn.dataset.variantTitle;
    const sellingPlan = btn.dataset.sellingPlan || '';

    // Sync naar hoofd buy box
    const mainCards = document.querySelectorAll('.cro-variant-card');
    mainCards.forEach(card => card.classList.remove('cro-variant-card--selected'));
    const matchingCard = document.querySelector(`.cro-variant-card[data-variant-id="${variantId}"]`);
    if (matchingCard) {
      matchingCard.classList.add('cro-variant-card--selected');
      const radio = matchingCard.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    }

    const variantInput = document.getElementById('cro-variant-id');
    if (variantInput) variantInput.value = variantId;

    setSellingPlan(sellingPlan);

    const priceEl = document.getElementById('cro-price-current');
    const compareEl = document.getElementById('cro-price-compare');
    const perDayEl = document.getElementById('cro-per-day');
    const savingsEl = document.getElementById('cro-savings-amount');
    if (priceEl) priceEl.textContent = price;
    if (compareEl) compareEl.textContent = compare;
    if (perDayEl) {
      if (perDayEl.childNodes[0]) perDayEl.childNodes[0].textContent = perDay;
      else perDayEl.textContent = perDay;
    }

    // Sticky bar
    if (savingsEl) {
      const priceNum = parseFloat(price.replace('€', '').replace(',', '.'));
      const compareNum = parseFloat(compare.replace('€', '').replace(',', '.'));
      const savings = (compareNum - priceNum).toFixed(2).replace('.', ',');
      savingsEl.textContent = '€' + savings;
    }

    const stickyVariant = document.getElementById('cro-sticky-variant');
    const stickyPerDay = document.getElementById('cro-sticky-per-day');
    if (stickyVariant) stickyVariant.textContent = variantTitle;
    if (stickyPerDay) {
      if (stickyPerDay.childNodes[0]) stickyPerDay.childNodes[0].textContent = perDay;
      else stickyPerDay.textContent = perDay;
    }

    const selTitle = document.getElementById('cro-midcta-selected-title');
    const selPrice = document.getElementById('cro-midcta-selected-price');
    const selPerDay = document.getElementById('cro-midcta-selected-perday');
    if (selTitle) selTitle.textContent = variantTitle;
    if (selPrice) selPrice.textContent = price;
    if (selPerDay) {
      if (selPerDay.childNodes[0]) selPerDay.childNodes[0].textContent = perDay;
      else selPerDay.textContent = perDay;
    }
  };

  // ─── MID-PAGE CTA ATC ────────────────────────────────────────────
  window.croMidCtaATC = function () {
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    const form = document.querySelector('.cro-product-form');
    if (form) {
      form.querySelector('[name="id"]').value = variantId;
      form.submit();
    }
  };

  // ─── VARIANT CARD CLICK (entire card clickable) ──────────────────
  document.querySelectorAll('.cro-variant-card').forEach(card => {
    card.addEventListener('click', function () {
      const radio = this.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        croSelectVariant(radio);
      }
    });
  });

  // ─── UPSELL MODAL ────────────────────────────────────────────────
  // Upsell chain: vi=0→1, vi=1→2, vi=2→3, vi=3 = geen popup (duurste)

  // Variant data: [variantId, title, days, price_cents]
  // Dynamisch opgebouwd vanuit de DOM na render
  const UPSELL_LAST_VI = 3; // geen popup bij deze vi

  let pendingVariantId = null;
  let upsellVariantId = null;

  function getSelectedVi() {
    const selected = document.querySelector('.cro-variant-card--selected');
    return selected ? parseInt(selected.dataset.vi) : 1;
  }

  function getCardByVi(vi) {
    return document.querySelector(`.cro-variant-card[data-vi="${vi}"]`);
  }

  function parsePrice(priceStr) {
    // e.g. "€54,98" or "54.98" → float
    return parseFloat(priceStr.replace(/[^ 0-9.,]/g, '').replace(',', '.'));
  }

  function showUpsellModal(currentVi) {
    const nextVi = currentVi + 1;
    const currentCard = getCardByVi(currentVi);
    const nextCard = getCardByVi(nextVi);
    if (!nextCard || !currentCard) return false;

    upsellVariantId = nextCard.dataset.variantId;

    // Compute values
    const currentDays = parseInt(currentCard.dataset.days) || 60;
    const nextDays = parseInt(nextCard.dataset.days) || 90;
    const extraDays = nextDays - currentDays;
    const currentPrice = parsePrice(currentCard.dataset.price);
    const nextPrice = parsePrice(nextCard.dataset.price);
    const diff = (nextPrice - currentPrice).toFixed(2).replace('.', ',');
    const currentTitle = currentCard.dataset.variantTitle || currentCard.querySelector('.cro-variant-card__title')?.textContent || `${currentDays} ${getDaysUnit()}`;
    const nextTitle = nextCard.dataset.variantTitle || nextCard.querySelector('.cro-variant-card__title')?.textContent || `${nextDays} ${getDaysUnit()}`;

    // Update modal copy
    const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    setText('cro-upsell-extra-days', extraDays);
    setText('cro-upsell-extra-days2', extraDays);
    setText('cro-upsell-target-days', nextDays);
    setText('cro-upsell-target-days2', nextDays);
    setText('cro-upsell-current-days', currentDays);
    setText('cro-upsell-diff', `€${diff}`);
    setText('cro-upsell-variant-label', `${nextTitle} | ${nextDays} ${getDaysUnit()}`);
    setText('cro-upsell-accept-title', nextTitle);
    setText('cro-upsell-decline-title', currentTitle);

    const overlay = document.getElementById('cro-upsell-overlay');
    if (overlay) {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const acceptBtn = document.getElementById('cro-upsell-accept');
      if (acceptBtn) acceptBtn.focus();
    }
    return true;
  }

  function closeUpsellModal() {
    const overlay = document.getElementById('cro-upsell-overlay');
    if (overlay) overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function fireATCPixel(variantId, price) {
    try {
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_ids: [String(variantId)],
          content_type: 'product_variant',
          value: price,
          currency: 'EUR'
        });
      }
      if (window.ttq) {
        window.ttq.track('AddToCart', {
          content_id: String(variantId),
          content_type: 'product',
          value: price,
          currency: 'EUR'
        });
      }
    } catch(e) {}
  }

  function addToCartAndRedirect(variantId, sellingPlanId) {
    const card = document.querySelector(`.cro-variant-card[data-variant-id="${variantId}"]`);
    const price = card ? parsePrice(card.dataset.price) : 0;

    const body = { id: variantId, quantity: 1 };
    if (sellingPlanId) body.selling_plan = sellingPlanId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (res.ok) {
        fireATCPixel(variantId, price);
        window.location.href = '/cart';
      } else {
        // Fallback: form submit
        const form = document.querySelector('.cro-product-form');
        if (form) { form.querySelector('[name="id"]').value = variantId; form.submit(); }
      }
    })
    .catch(function() {
      const form = document.querySelector('.cro-product-form');
      if (form) { form.querySelector('[name="id"]').value = variantId; form.submit(); }
    });
  }

  function handleATC(variantId, currentVi) {
    if (currentVi < UPSELL_LAST_VI) {
      pendingVariantId = variantId;
      showUpsellModal(currentVi);
    } else {
      // Duurste variant — direct toevoegen
      addToCartAndRedirect(variantId, pendingSellingPlanId);
    }
  }

  // Intercept ATC form submit
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      const currentVi = getSelectedVi();
      if (currentVi < UPSELL_LAST_VI) {
        e.preventDefault();
        handleATC(document.getElementById('cro-variant-id')?.value, currentVi);
      }
      // vi=3: gewoon doorgaan
    });
  }

  // Upsell accepteren → voeg volgende variant toe
  const acceptBtn = document.getElementById('cro-upsell-accept');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      closeUpsellModal();
      if (upsellVariantId) {
        addToCartAndRedirect(upsellVariantId, null);
      }
    });
  }

  // Upsell afwijzen → voeg huidige variant toe
  const declineBtn = document.getElementById('cro-upsell-decline');
  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      closeUpsellModal();
      if (pendingVariantId) {
        addToCartAndRedirect(pendingVariantId, pendingSellingPlanId);
      }
    });
  }

  const closeBtn = document.getElementById('cro-upsell-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeUpsellModal);
  }

  const overlayEl = document.getElementById('cro-upsell-overlay');
  if (overlayEl) {
    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) closeUpsellModal();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const overlay = document.getElementById('cro-upsell-overlay');
      if (overlay && !overlay.hasAttribute('hidden')) closeUpsellModal();
    }
  });

  // Sticky ATC ook intercepten
  window.croStickyATC = function () {
    const currentVi = getSelectedVi();
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    handleATC(variantId, currentVi);
  };

  // Mid-page CTA ook intercepten
  window.croMidCtaATC = function () {
    const currentVi = getSelectedVi();
    const variantId = document.getElementById('cro-variant-id')?.value;
    if (!variantId) return;
    handleATC(variantId, currentVi);
  };

  // ─── INIT: set selling plan for default selected card ─
  const defaultCard = document.querySelector('.cro-variant-card--selected');
  if (defaultCard) {
    pendingSellingPlanId = defaultCard.dataset.sellingPlan || null;
  }

})();
